<template>
  <div class="login-container" v-bind:style="{'background-image': 'url(http://image.bjh.snsports.cn/FhGnD8dXm7RpUWqvnUOJvvrU8aoT)'}">
    <div class="layer">
      <img src="@/assets/images/login_layer_bg.png">
    </div>
    <!--    <div class="left-tops-off">-->
    <!--      <img src="@/assets/images/bmb_logo_icon.png">-->
    <!--    </div>-->
    <div class="bing-qiu-logo">
      <img src="@/assets/images/bingqiu_logo1.png">
    </div>
    <div class="bottom-logo">
      <span>Power by©️ 斑马邦体育</span>
      <div @click="goSite" style="cursor: pointer;">www.banmabang.cn</div>
    </div>
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
      <p class="title">用户登录</p>
      <el-form-item prop="username">
        <span class="svg-container">
          <svg-icon icon-class="user" />
        </span>
        <el-input v-model="loginForm.username" name="username" type="text" auto-complete="on" placeholder="用户名" />
      </el-form-item>
      <el-form-item prop="password">
        <span class="svg-container">
          <svg-icon icon-class="password" />
        </span>
        <el-input
          :type="pwdType"
          v-model="loginForm.password"
          name="password"
          auto-complete="on"
          placeholder="密码"
          @keyup.enter.native="handleLogin" />
        <span class="show-pwd" @click="showPwd">
          <svg-icon :icon-class="pwdType === 'password' ? 'eye' : 'eye-open'" />
        </span>
      </el-form-item>
      <el-form-item class="el-form-customer">
        <el-button :loading="loading" class="login-btn" type="primary" style="width:100%;" @click.native.prevent="handleLogin">
          登 录
        </el-button>
      </el-form-item>
      <!--<div class="tips">-->
      <!--<span style="margin-right:20px;">username: testAdmin</span>-->
      <!--<span> password: 123456</span>-->
      <!--</div>-->
    </el-form>
  </div>
</template>

<script>
import { isvalidUsername } from '@/utils/validate'

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error('请输入正确的用户名'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePass }]
      },
      loading: false,
      pwdType: 'password',
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('LoginByUsername', this.loginForm).then(() => {
            this.loading = false
            this.$router.push({ path: this.redirect || '/' })
          }).catch(() => {
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    goSite() {
      window.location.href = 'http://www.banmabang.cn'
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  $bg:#2d3a4b;
  $light_gray:#eee;

  /* reset element-ui css */
  .login-container {
    .el-input {
      display: inline-block;
      height: 47px;
      width: 85%;
      input {
        background: transparent;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px 12px 15px;
        color: #000000;
        height: 47px;
        &:-webkit-autofill {
          -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
          -webkit-text-fill-color: #fff !important;
        }
      }
    }
    .el-form-item {
      border: 1px solid #0091FF;
      background: #ffffff;
      border-radius: 4px;
      color: #454545;
      width: 80%;
      margin: 25px auto 0;
    }
    .el-form-customer{
      border: 0 !important;
    }
  }

</style>

<style rel="stylesheet/scss" lang="scss" scoped>
  $bg:#2d3a4b;
  $dark_gray:#889aa4;
  $light_gray:#eee;
  @media screen and (min-width: 300px) and (max-width: 375px) {
    .bing-qiu-logo{
      position: fixed;
      top: 10%;
      left: 50%;
      transform: translateX(-50%);
      img{
        width: 365px;
        height: 83px;
      }
    }
    .login-form{
      width: 85%;
      height: 284px;
      background-color: #FFFFFF;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      padding-top: 40px;
      box-sizing: border-box;
      border-radius: 4px;
      .title{
        text-align: center;
        color: #0091FF;
        font-size: 16px;
        padding-top: 15px;
        box-sizing: border-box;
        position: absolute;
        left: 50%;
        top: 7px;
        font-weight: 500;
        margin: 0px auto 45px auto;
        transform: translateX(-50%);
      }
      .el-button{
        border: 0 !important;
      }
      .el-button--primary{
        width: 278px;
        height: 40px;
        background-color: #0091FF;
        border-radius: 4px;
      }
    }
  }
  @media screen and (min-width: 376px) {
    .bing-qiu-logo{
      position: fixed;
      top: 50%;
      left: 15%;
      transform: translateY(-50%);
      img{
        width: 365px;
        height: 83px;
      }
    }
    .login-form{
      width: 28%;
      height: 284px;
      background-color: #FFFFFF;
      margin-left: 56%;
      top: 50%;
      transform: translateY(-50%);
      position: absolute;
      padding-top: 40px;
      box-sizing: border-box;
      border-radius: 4px;
      .title{
        text-align: center;
        color: #0091FF;
        font-size: 16px;
        padding-top: 15px;
        box-sizing: border-box;
        position: absolute;
        left: 50%;
        font-weight: 500;
        top: 7px;
        margin: 0px auto 45px auto;
        transform: translateX(-50%);
      }
      .el-button{
        border: 0 !important;
      }
      .el-button--primary{
        width: 278px;
        height: 40px;
        background-color: #0091FF;
        border-radius: 4px;
      }
    }
  }
  .login-container {
    position: fixed;
    height: 100%;
    width: 100%;
    background-color: $bg;
    /*background-image: url("../../assets/images/login_bg.png");*/
    background-size: cover;
    .layer{
      img{
        position: fixed;
        width: 100%;
        height: 100%;
        opacity: 0.8;
      }
    }
    .left-tops-off{
      position: fixed;
      top: 20px;
      left: 28px;
      img{
        width: 90px;
        height: 52px;
      }
    }
    .bottom-logo{
      position: fixed;
      bottom: 33px;
      left: 50%;
      transform: translateX(-50%);
      color: #F0F0F0;
      font-size: 12px;
      text-align: center;
      div{
        width: 113px;
        border-bottom: 1px solid #F0F0F0;
        margin: 5px auto 0;
      }
    }
    .tips {
      font-size: 14px;
      color: #fff;
      margin-bottom: 10px;
      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }
    .svg-container {
      padding: 6px 5px 6px 15px;
      color: $dark_gray;
      vertical-align: middle;
      width: 30px;
      display: inline-block;
    }
    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
    }
  }

</style>
